import { render, staticRenderFns } from "./draw-food.vue?vue&type=template&id=42e6e6b4&scoped=true&"
import script from "./draw-food.vue?vue&type=script&lang=js&"
export * from "./draw-food.vue?vue&type=script&lang=js&"
import style0 from "./draw-food.vue?vue&type=style&index=0&id=42e6e6b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6e6b4",
  null
  
)

export default component.exports